const Heading = {
	baseStyle: {
		fontFamily: "Inter",
	},
};

export default Heading;
